const CALENDAR_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const MS_PER_DAY = 86_400_000;
/** Number of whole days between the Unix epoch and `date`. */
export function toEpochDay(date) {
    const parts = parseParts(date);
    if (parts === null) {
        throw new RangeError(`Not a calendar date: "${date}"`);
    }
    return Math.round(Date.UTC(parts.year, parts.month - 1, parts.day) / MS_PER_DAY);
}
/** Inverse of {@link toEpochDay}. */
export function fromEpochDay(epochDay) {
    if (!Number.isInteger(epochDay)) {
        throw new RangeError(`Not an integer epoch day: ${epochDay}`);
    }
    return formatUtc(new Date(epochDay * MS_PER_DAY));
}
/** True when `value` is a syntactically and calendrically valid date. */
export function isCalendarDate(value) {
    return typeof value === 'string' && parseParts(value) !== null;
}
export function addDays(date, days) {
    return fromEpochDay(toEpochDay(date) + days);
}
/** Negative when `a` is earlier, positive when later, zero when equal. */
export function compareDates(a, b) {
    return toEpochDay(a) - toEpochDay(b);
}
export function minDate(a, b) {
    return compareDates(a, b) <= 0 ? a : b;
}
export function maxDate(a, b) {
    return compareDates(a, b) >= 0 ? a : b;
}
/** Days from `a` (inclusive) to `b` (exclusive). */
export function daysBetween(a, b) {
    return toEpochDay(b) - toEpochDay(a);
}
function parseParts(value) {
    const match = CALENDAR_DATE_PATTERN.exec(value);
    if (match === null) {
        return null;
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    // Round-tripping through UTC rejects impossible days such as 2026-02-30,
    // which the pattern alone happily accepts.
    const asDate = new Date(Date.UTC(year, month - 1, day));
    if (formatUtc(asDate) !== value) {
        return null;
    }
    return { year, month, day };
}
function formatUtc(date) {
    const year = String(date.getUTCFullYear()).padStart(4, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
//# sourceMappingURL=calendarDate.js.map